import { pip } from './pages/pip/pip';
import { pep } from './pages/pep/pep';
import { browseAndCategory } from './pages/browseAndCategory/browseAndCategory';
import { search } from './pages/search/search';
import { collections } from './pages/collections/collections';
import { compare } from './pages/compare/compare';
import { packages } from './pages/packages/packages';
import { giftcards } from './pages/giftcards/giftcards';
import { exerciseMyPrivacyRights } from './pages/exerciseMyPrivacyRights/exerciseMyPrivacyRights';
import { seoExperience } from './pages/seo-experience/seo-experience';
import { optOut } from './pages/optOut/optOut';
import { buyItAgain } from './pages/buyItAgain/buyItAgain';
import { pathToProNetwork } from './pages/pathToProNetwork/pathToProNetwork';
import { articleExperience } from './pages/article/article';
import { localAd } from './pages/localAd/localAd';
import { content } from './pages/content/content';

export const page = () => {
  seoExperience();
  browseAndCategory();
  pep();
  search();
  collections();
  compare();
  packages();
  giftcards();
  optOut();
  pip();
  exerciseMyPrivacyRights();
  buyItAgain();
  pathToProNetwork();
  articleExperience();
  localAd();
  content();
};
